import React from 'react'

function TermsAndConditions() {
  return (
    <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 main_content_terms">
            <div className="row justify-content-center">
                <div className="col-12 text-center my-5">
                    <h1>Terms & Conditions</h1>
                </div>
                <div className="col-lg-10 col-11">
                    <div className="row">
                        <p>Welcome to LOOV, a product developed by <a target="_blank" rel="noopener noreferrer" href="https://msitpark.org/">MS IT PARK Pvt Ltd</a>. By accessing or using LOOV's desktop monitoring software and services, you agree to the following Terms & Conditions.</p>
                        <div className="col-12">
                            <div className="row">
                                <h5>1. Acceptance of Terms</h5>
                                <p>By using LOOV, you confirm that you understand and agree to these Terms. If you do not agree, please do not use the service.</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>2. Service Overview</h5>
                                <p>LOOV is a productivity and employee monitoring software designed for companies to track and analyze desktop activity including screen usage, screenshots, and work behavior insights.</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>3. User Responsibilities</h5>
                                <b>You agree to:</b>
                                <ul>
                                    <li>Use LOOV only for ethical and legal business purposes</li>
                                    <li>Inform your employees or team members that they are being monitored</li>
                                    <li>Maintain the confidentiality of your account credentials</li>
                                    <li>Avoid tampering with or misusing the service</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>4. Data Privacy</h5>
                                <p>LOOV respects your data privacy. We do not capture sensitive information such as passwords or personal files. Monitoring is focused on productivity-related metrics only.</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>5. Payments & Refunds</h5>
                                <p>All LOOV plans are subscription-based. By subscribing, you agree to pay the fees associated with your selected plan. We do not offer refunds</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>6. Termination</h5>
                                <p>We reserve the right to suspend or terminate access to LOOV if you violate these Terms or misuse the platform.</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>7. Intellectual Property</h5>
                                <p>We are not liable for any indirect losses, including lost profits, data, or business interruption resulting from the use of LOOV.</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>9. Updates to Terms</h5>
                                <p>We may update these Terms from time to time. Continued use of LOOV after changes constitutes acceptance of the new terms.</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <h5>10. Contact Us</h5>
                                <p>For support or queries, contact:<br/><a target="_blank" rel="noopener noreferrer" href="mailto:support@loov.in">support@loov.in</a></p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          
        </div>
    </div>
  )
}

export default TermsAndConditions
